/* eslint-disable */
export default {
  noRecords: '未找到任何最近的记录。',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
